document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('SizeGuideDrawer');
  if (!modal) return;

  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  const content = modal.querySelector('.sg-modal__content');
  const openButtons = document.querySelectorAll('.sg-open');
  const closeButtons = modal.querySelectorAll('[data-sg-close]');

  const tabButtons = modal.querySelectorAll('.sg-tab');
  const tabPanels = {
    guide: modal.querySelector('#sg-guide'),
    conversion: modal.querySelector('#sg-conversion'),
    measure: modal.querySelector('#sg-measure'),
  };

  const unitButtons = modal.querySelectorAll('.sg-unit');
  const cmTable = modal.querySelector('.sg-cm');
  const inTable = modal.querySelector('.sg-in');

  const accordionButtons = modal.querySelectorAll('.sg-acc-toggle');

  let lastTrigger = null;

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], area[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]'
      )
    ).filter((el) => !el.hasAttribute('hidden') && el.offsetParent !== null);
  }

  function trapFocus(event) {
    if (event.key !== 'Tab') return;

    const focusable = getFocusableElements(content);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openModal(trigger) {
    lastTrigger = trigger || document.activeElement || null;

    modal.hidden = false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sg-modal-open');
    document.body.classList.add('sg-modal-open');

    requestAnimationFrame(() => {
      content.focus();
    });

    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.documentElement.classList.remove('sg-modal-open');
    document.body.classList.remove('sg-modal-open');

    document.removeEventListener('keydown', onKeydown);

    if (lastTrigger) lastTrigger.focus();
  }

  function onKeydown(event) {
    if (!modal.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    trapFocus(event);

    if (
      (event.key === 'ArrowRight' || event.key === 'ArrowLeft') &&
      document.activeElement &&
      document.activeElement.classList.contains('sg-tab')
    ) {
      const tabs = Array.from(tabButtons);
      const currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
      } else {
        nextIndex = currentIndex === 0 ? tabs.length - 1 : currentIndex - 1;
      }

      event.preventDefault();
      activateTab(tabs[nextIndex]);
      tabs[nextIndex].focus();
    }
  }

  function activateTab(button) {
    const tab = button.dataset.tab;

    tabButtons.forEach((btn) => {
      const isActive = btn === button;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    Object.entries(tabPanels).forEach(([key, panel]) => {
      if (!panel) return;
      const isActive = key === tab;
      panel.classList.toggle('active', isActive);
      panel.hidden = !isActive;
    });
  }

  function activateUnit(button) {
    const unit = button.dataset.unit;

    unitButtons.forEach((btn) => {
      const isActive = btn === button;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (cmTable && inTable) {
      const showCm = unit === 'cm';
      cmTable.classList.toggle('active', showCm);
      inTable.classList.toggle('active', !showCm);
      cmTable.hidden = !showCm;
      inTable.hidden = showCm;
    }
  }

  function toggleAccordion(button) {
    const accordion = button.closest('.sg-accordion');
    const contentId = button.getAttribute('aria-controls');
    const accContent = contentId ? modal.querySelector(`#${contentId}`) : null;
    if (!accordion || !accContent) return;

    const isOpen = accordion.classList.contains('is-open');
    accordion.classList.toggle('is-open', !isOpen);
    button.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    accContent.hidden = isOpen;
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', () => openModal(button));
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target.closest('[data-sg-close]')) return;
    if (event.target.classList.contains('sg-modal__overlay')) {
      closeModal();
    }
  });

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => activateTab(button));
  });

  unitButtons.forEach((button) => {
    button.addEventListener('click', () => activateUnit(button));
  });

  accordionButtons.forEach((button) => {
    button.addEventListener('click', () => toggleAccordion(button));
  });
});